import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "相似度 = ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " / 100", -1)
const _hoisted_3 = { style: {"margin-left":"10px"} }
const _hoisted_4 = { style: {"margin-left":"10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_card = _resolveComponent("miezz-card")!

  return (_openBlock(), _createBlock(_component_miezz_card, { title: "比对Excel重复值" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: _ctx.form.Data,
        rules: _ctx.form.Rules,
        ref: "ruleForm",
        "label-width": "120px",
        inline: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            prop: "Columns",
            label: "需要比较的列"
          }, {
            default: _withCtx(() => [
              (_ctx.form.Data.Columns)
                ? (_openBlock(), _createBlock(_component_el_table, {
                    key: 0,
                    data: _ctx.form.Data.Columns,
                    border: "",
                    stripe: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "Name",
                        label: "名称"
                      }, {
                        default: _withCtx(({ row, $index }) => [
                          _createVNode(_component_el_form_item, {
                            prop: `Columns[${$index}].Name`,
                            rules: _ctx.rules.ColumnName
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: row.Name,
                                "onUpdate:modelValue": ($event: any) => ((row.Name) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["prop", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "Power",
                        label: "权重（1-100）"
                      }, {
                        default: _withCtx(({ row, $index }) => [
                          _createVNode(_component_el_form_item, {
                            prop: `Columns[${$index}].Power`,
                            rules: _ctx.rules.ColumnPower
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: row.Power,
                                "onUpdate:modelValue": ($event: any) => ((row.Power) = $event),
                                number: true,
                                pattern: "[0-9]",
                                greaterThanNumber: 0
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["prop", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "CompareIgnores",
                        label: "忽略值"
                      }, {
                        default: _withCtx(({ row, $index }) => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.CompareIgnores, (ignore, ignoreIndex) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: ignoreIndex,
                              style: {"margin-right":"5px"},
                              closable: "",
                              "disable-transitions": false,
                              onClose: ($event: any) => (_ctx.handleRemoveCompareIgnore(row, ignoreIndex))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(ignore), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClose"]))
                          }), 128)),
                          (row.CompareIgnoreVisible)
                            ? (_openBlock(), _createBlock(_component_miezz_input, {
                                key: 0,
                                modelValue: row.CompareIgnore,
                                "onUpdate:modelValue": ($event: any) => ((row.CompareIgnore) = $event),
                                style: {"width":"100px"},
                                size: "small",
                                onHandleBlur: ($event: any) => (_ctx.handleAddCompareIgnore(row))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"]))
                            : (_openBlock(), _createBlock(_component_miezz_button, {
                                key: 1,
                                model: _ctx.btnShowCompareIgnore,
                                onHandleClick: 
                  (arg1, arg2) => _ctx.handleRowButtonClick(arg1, row, arg2, $index)
                
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" + 添加忽略值 ")
                                ]),
                                _: 2
                              }, 1032, ["model", "onHandleClick"]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "操作",
                        fixed: "right"
                      }, {
                        default: _withCtx(({ row, $index }) => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_miezz_button, {
                              model: _ctx.btnDeleteColumn,
                              onHandleClick: 
                    (arg1, arg2) =>
                      _ctx.handleRowButtonClick(arg1, row, arg2, $index)
                  
                            }, null, 8, ["model", "onHandleClick"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"]))
                : _createCommentVNode("", true),
              _createVNode(_component_miezz_button, {
                style: {"margin-top":"10px"},
                model: _ctx.btnAddColumn,
                onHandleClick: _ctx.handleClick
              }, null, 8, ["model", "onHandleClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "公式" }, {
            default: _withCtx(() => [
              _hoisted_1,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.Columns?.filter(
            (it) => it.Name && it.Power
          ), (column, columnIndex) => {
                return (_openBlock(), _createElementBlock("span", { key: columnIndex }, _toDisplayString(column.Name) + "的相似度 x 权重" + _toDisplayString(column.Power), 1))
              }), 128)),
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "最低相似度" }, {
            default: _withCtx(() => [
              _createVNode(_component_miezz_input, {
                style: {"width":"70px"},
                modelValue: _ctx.form.Data.MinRate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.MinRate) = $event)),
                number: true,
                pattern: "[0-9]",
                greaterThanNumber: 0
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form_item, {
              label: "A文件",
              prop: "PositionA.File",
              rules: _ctx.rules.PositionAFile,
              style: {"display":"inline-flex","min-width":"200px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  action: "#",
                  accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  "show-file-list": false,
                  "before-upload": _ctx.handleUploadA,
                  limit: 1
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("添加文件 "),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.fileA?.name), 1)
                  ]),
                  _: 1
                }, 8, ["before-upload"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_el_form_item, {
              label: "起始行号：",
              prop: "PositionA.Row",
              rules: _ctx.rules.PositionARow,
              style: {"display":"inline-flex","min-width":"200px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_input, {
                  style: {"width":"70px"},
                  modelValue: _ctx.form.Data.PositionA.Row,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Data.PositionA.Row) = $event)),
                  number: true,
                  pattern: "[0-9]",
                  greaterThanNumber: 0
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["rules"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.Columns, (column, columnIndex) => {
              return (_openBlock(), _createBlock(_component_el_form_item, {
                key: columnIndex,
                label: `${column.Name}列号：`,
                prop: `PositionA.Columns[${columnIndex}]`,
                rules: _ctx.rules.PositionAColumns,
                style: {"display":"inline-flex","min-width":"200px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_miezz_input, {
                    style: {"width":"70px"},
                    modelValue: _ctx.form.Data.PositionA.Columns[columnIndex],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.form.Data.PositionA.Columns[columnIndex]) = $event),
                    number: true,
                    pattern: "[0-9]",
                    greaterThanNumber: 0
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["label", "prop", "rules"]))
            }), 128))
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form_item, {
              label: "B文件",
              prop: "PositionB.File",
              rules: _ctx.rules.PositionBFile,
              style: {"display":"inline-flex","min-width":"200px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  action: "#",
                  accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  "show-file-list": false,
                  "before-upload": _ctx.handleUploadB,
                  limit: 1
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("添加文件 "),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.fileB?.name), 1)
                  ]),
                  _: 1
                }, 8, ["before-upload"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_el_form_item, {
              label: "起始行号：",
              prop: "PositionB.Row",
              rules: _ctx.rules.PositionBRow,
              style: {"display":"inline-flex","min-width":"200px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_input, {
                  style: {"width":"70px"},
                  modelValue: _ctx.form.Data.PositionB.Row,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Data.PositionB.Row) = $event)),
                  number: true,
                  pattern: "[0-9]",
                  greaterThanNumber: 0
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["rules"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.Columns, (column, columnIndex) => {
              return (_openBlock(), _createBlock(_component_el_form_item, {
                key: columnIndex,
                label: `${column.Name}列号：`,
                prop: `PositionB.Columns[${columnIndex}]`,
                rules: _ctx.rules.PositionBColumns,
                style: {"display":"inline-flex","min-width":"200px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_miezz_input, {
                    style: {"width":"70px"},
                    modelValue: _ctx.form.Data.PositionB.Columns[columnIndex],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.form.Data.PositionB.Columns[columnIndex]) = $event),
                    number: true,
                    pattern: "[0-9]",
                    greaterThanNumber: 0
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["label", "prop", "rules"]))
            }), 128)),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_button, {
                  model: _ctx.btnSubmit,
                  onHandleClick: _ctx.handleClick
                }, null, 8, ["model", "onHandleClick"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }))
}